import { useAppSelector } from '../../../app/hooks'
import { InitState } from '../../../redux/reducers/root/initialState'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'

export function useIsRecommendedPriceEnabled() {
  const { isActive: isRecommendedPriceFeatureEnabled } = useFeatureSwitch(
    FeatureSwitch.PPA_12279_RECOMMENDED_PRICE_FIRST_ITERATION
  )
  const isRecommendedPriceFlowOptionEnabled = useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.recommendedPriceEnabled === true
  )

  return isRecommendedPriceFeatureEnabled && isRecommendedPriceFlowOptionEnabled
}
